module.exports = __webpack_public_path__ + "assets/log-out.487c8f1b.svg";